import React from "react";
import classNames from "classnames";
import styled from "styled-components";

const StyledLabel = styled.div`
  color: black;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 20px 0 0 -50%;
  width: 100%;
  text-align: center;
`;

export default function Spinner(props) {
    const { classes = {}, label } = props;
    return (
        <div className={classNames(classes.spinnerAddOn, "spinner")}>
            <svg className="circular">
                <circle className="path" cx="20" cy="20" r="15" />
            </svg>
            {label && <StyledLabel>{label}</StyledLabel>}
        </div>
    );
}
